import dayjs from 'dayjs';

export const isAllValue = (value) =>
  value?.toLowerCase() === 'all' ? '' : value;

export const filterBuilder = (filter) => {
  const dateFormat = 'YYYY-MM-DD';
  const [startDate, endDate] = filter?.submissionDate || [];

  const result = {
    ...filter,
    regional: isAllValue(filter?.regional),
    provinceId: isAllValue(filter?.provinceId),
    cityId: isAllValue(filter?.cityId),
    districtId: isAllValue(filter?.districtId),
    villageId: isAllValue(filter?.villageId),
    startDate: dayjs(startDate).format(dateFormat),
    endDate: dayjs(endDate).format(dateFormat),
    // statusStartDate: dayjs(filter?.statusDate).format(dateFormat),
    // statusEndDate: dayjs(filter?.statusDate).format(dateFormat),
  };

  delete result['submissionDate'];
  delete result['statusDate'];

  return result;
};

export const filterBuilder2 = (filter) => {

  const result = {
    ...filter,
    regional: isAllValue(filter?.regional),
    provinceId: isAllValue(filter?.provinceId),
    cityId: isAllValue(filter?.cityId),
    districtId: isAllValue(filter?.districtId),
    villageId: isAllValue(filter?.villageId),
    // statusStartDate: dayjs(filter?.statusDate).format(dateFormat),
    // statusEndDate: dayjs(filter?.statusDate).format(dateFormat),
  };

  delete result['submissionDate'];
  delete result['statusDate'];

  return result;
};


export const rebuildDatesFilter = (query) => {
  const { startDate, endDate, statusStartDate } = query;
  const submissionDate = [dayjs(startDate).toDate(), dayjs(endDate).toDate()];
  const statusDate = dayjs(statusStartDate).toDate();
  return { ...query, submissionDate, statusDate };
};
